import React from "react";
import Barcode from "react-barcode";
import { useFormatPrice } from "hooks";

const LabelWidget = ({ value, item }) => {
  const formatPrice = useFormatPrice();
  if (!item) return <div className="label-cell empty" />;

  const sku = item.varProd?.skuCode || item.prod?.skuCode;
  const title = item.prodTitle;
  const price = item.varProd?.rtlPrice || item.prod?.rtlPrice;

  return (
    <div
      style={{
        display: "grid",
        justifyContent: "center",
        letterSpacing: "0.5px",
        padding: "10px",
      }}
    >
      {/* Store Name */}
      {value.showOutlet && (
        <span
          style={{
            textAlign: "center",
            fontWeight: "bold",
            fontSize: "16px",
          }}
        >
          {value?.outletName}
        </span>
      )}

      {/* Barcode */}
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Barcode
          value={sku}
          height={40}
          width={1.5}
          fontSize={12}
          format="CODE128"
          displayValue={false}
        />
      </div>

      {/* SKU/Numbers */}
      {value.showSku && (
        <div
          style={{
            textAlign: "center",
            fontSize: "12px",
          }}
        >
          {sku}
        </div>
      )}

      {/* Product Label */}
      {value.showProdTitle && (
        <div
          style={{
            textAlign: "center",
            fontSize: "14px",
          }}
        >
          {title}
        </div>
      )}

      {/* Retail Price */}
      {value.showRtlPrice && (
        <div
          style={{
            textAlign: "center",
            fontWeight: 600,
            fontSize: "15px",
            marginTop: "7px",
          }}
        >
          {formatPrice(price)}
        </div>
      )}
    </div>
  );
};

export default LabelWidget;
